import React from 'react';
import AddSchoolData from './AddSchoolData';

const EditSchoolData = (props) => {
  return (
    <AddSchoolData uuid={props.match.params.uuid} />
  )
}

export default EditSchoolData;